export default "__VITE_ASSET__DlPFr2TG__"